import React from "react";
//components
import Container from "../../../components/container/container";
//images and icons
import PrivacyPolicy from "../../../assets/images/icons/privacy-policy.png";
import CustomerCare from "../../../assets/images/icons/customer-care.svg";
import Faq from "../../../assets/images/icons/faq.png";

export default function Help() {
  return (
    <div data-test="help-page">
      <Container>
        <main className="py-8">
          <div className="max-w-3xl mx-auto lg:max-w-7xl">
            <p className=" text-2xl text-primary mt-5 mb-6 capitalize font-bold">
              Help Center
            </p>
            <p className="text-[20px] dark:text-[#BCBCBC] my-2 max-w-6xl">
              Welcome to the Help Center — your go-to place for quick support.
              Whether you’re ordering meals or shopping for groceries, you’ll
              find answers here.
            </p>
            <p className="text-[20px] dark:text-[#BCBCBC] my-2 max-w-6xl">
              Browse the sections below or contact our friendly support team
              anytime — we’re happy to help
            </p>

            <div
              className="sm:mt-16 justify-center items-center mx-auto"
              data-test="helpPage"
            >
              <section aria-labelledby="section-1-title">
                {/* Your content */}
                <a
                  href="/contact-us"
                  className="text-base text-start text-[#2b3674]"
                >
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 cursor-pointer shadow-lg rounded-lg h-[91px] sm:py-4 mb-4 sm:mb-8">
                    <div className="flex">
                      <img src={CustomerCare} alt="contact" />
                      <div className="ml-5">
                        <span className="dark:text-[#9CA3AF]">Contact Us</span>
                      </div>
                    </div>
                  </div>
                </a>

                <a
                  href="/privacy-policy"
                  className="text-base text-start text-[#2b3674]"
                >
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 cursor-pointer shadow-lg rounded-lg h-[91px] sm:py-4 mb-4 sm:mb-8">
                    <div className="flex">
                      <img src={PrivacyPolicy} alt="privacy" />
                      <div className="ml-5">
                        <span className="dark:text-[#9CA3AF]">
                          Privacy Policy
                        </span>
                      </div>
                    </div>
                  </div>
                </a>

                <a href="/faq" className="text-base text-start text-[#2b3674]">
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 cursor-pointer shadow-lg rounded-lg h-[91px] sm:py-4 mb-4 sm:mb-8">
                    <div className="flex">
                      <img src={Faq} alt="faq" />
                      <div className="ml-5">
                        <span className="dark:text-[#9CA3AF]">Faq</span>
                      </div>
                    </div>
                  </div>
                </a>
              </section>
            </div>
          </div>
        </main>
      </Container>
    </div>
  );
}
